import { TriggerEndpointKeys } from './triggerTypes'

import Settings from 'common/helpers/settings'

export const TriggerEndpoints = {
  [TriggerEndpointKeys.getAllTriggers]: (transmissionCode: string) => {
    return `${Settings.api.trigger}/v1/public/trigger/${transmissionCode}`
  },
  [TriggerEndpointKeys.getTrigger]: (transmissionCode: string, triggerId: string) => {
    return `${Settings.api.trigger}/v1/public/trigger/${transmissionCode}/${triggerId}`
  }
}
